export const errorsMessage: Record<string, string> = {
  internal_server_error: 'Lỗi máy chủ nội bộ',
  unauthorized: 'Không được ủy quyền',
  forbidden: 'Bị cấm',
  validation: 'Lỗi xác thực dữ liệu',
  admin_not_found: 'Không tìm thấy quản trị viên',
  admin_duplicate: 'Quản trị viên bị trùng',
  username_duplicate: 'Tên đăng nhập đã tồn tại',
  email_duplicate: 'Email đã tồn tại',
  phone_number_duplicate: 'Số điện thoại đã tồn tại',
  role_not_found: 'Không tìm thấy vai trò',
  report_not_found: 'Không tìm thấy báo cáo',
  activity_not_found: 'Không tìm thấy hoạt động',
  username_or_password_wrong: 'Tài khoản hoặc mật khẩu không chính xác',
  max_device_login: 'Bạn đã đăng nhập trên số lượng thiết bị tối đa.',
  email_or_phone_number_duplicate: 'Email hoặc số điện thoại đã tồn tại',
  update_password_faild: 'Cập nhật mật khẩu thất bại',
  refresh_token_not_found: 'Không tìm thấy refresh token',
  indicator_not_found: 'Không tìm thấy chỉ số',
  can_not_change_chart: 'Không thể thay đổi biểu đồ',
  indicator_invalid: 'Chỉ số không hợp lệ',
  unit_invalid: 'Đơn vị không hợp lệ',
  invalid_file_extension: 'Định dạng tệp không hợp lệ',
  job_not_found: 'Không tìm thấy công việc',
  can_not_delete_folder: 'Không thể xóa thư mục',
  indicator_value_invalid: 'Giá trị chỉ số không hợp lệ',
  province_not_found: 'Không tìm thấy tỉnh/thành phố',
  local_indicator_not_found: 'Không tìm thấy chỉ số địa phương',
  local_indicator_value_invalid: 'Giá trị chỉ số địa phương không hợp lệ',
  invalid_file: 'Tệp không hợp lệ',
  upload_file_failed: 'Tải tệp lên thất bại',
  not_edit_indicator_type: 'Không thể chỉnh sửa loại chỉ số',
  indicator_value_not_found: 'Không tìm thấy giá trị chỉ số',
  local_indicator_invalid: 'Chỉ số địa phương không hợp lệ',
  plan_duplicate: 'Gói đăng ký bị trùng',
  plan_not_found: 'Không tìm thấy gói đăng ký',
  addon_duplicate: 'Tiện ích bổ sung bị trùng',
  addon_not_found: 'Không tìm thấy tiện ích bổ sung',
  article_not_found: 'Không tìm thấy bài viết',
  category_not_found: 'Không tìm thấy danh mục',
  user_not_found: 'Không tìm thấy người dùng',
  default_package_not_delete: 'Không thể xóa gói mặc định',
  not_found: 'Không tìm thấy dữ liệu',
  tag_not_found: 'Không tìm thấy thẻ',
  tag_exist: 'Thẻ đã tồn tại',
  menu_config_exist: 'Cấu hình menu đã tồn tại',
  menu_not_exist: 'Không tìm thấy cấu hình menu',
  id_value_not_exist: 'Không tìm thấy giá trị ID',
  industry_indicator_not_found: 'Không tìm thấy chỉ số ngành',
  not_edit_industry_indicator_type: 'Không thể chỉnh sửa loại chỉ số ngành',
  industry_indicator_invalid: 'Chỉ số ngành không hợp lệ',
  industry_indicator_value_not_found: 'Không tìm thấy giá trị chỉ số ngành',
  err_false_checksum: 'Thông báo thanh toán thất bại: ERR_FALSE_CHECKSUM',
  encode_something_wrong: 'Giái mã thất bại',
};

export const errorsByMessages: Record<string, string> = {
  'Internal server error': 'Lỗi máy chủ nội bộ',
  Unauthorized: 'Chưa xác thực',
  Forbidden: 'Không có quyền truy cập',
  Validation: 'Lỗi xác thực dữ liệu',
  'Admin not found': 'Không tìm thấy quản trị viên',
  'Duplicate admin': 'Quản trị viên đã tồn tại',
  'Duplicate username': 'Tên người dùng đã tồn tại',
  'Duplicate email': 'Email đã tồn tại',
  'Duplicate phone number': 'Số điện thoại đã tồn tại',
  'Role not found': 'Không tìm thấy vai trò',
  'Report not found': 'Không tìm thấy báo cáo',
  'Activity not found': 'Không tìm thấy hoạt động',
  'Username or password wrong': 'Tên người dùng hoặc mật khẩu không đúng',
  'Bạn đã đạt giới hạn đăng nhập tối đa trên các thiết bị. Vui lòng đăng xuất khỏi một thiết bị khác để tiếp tục.':
    'Bạn đã đăng nhập trên số lượng thiết bị tối đa.',
  'Email or phone number duplicate': 'Email hoặc số điện thoại đã tồn tại',
  'Update password faild': 'Cập nhật mật khẩu thất bại',
  'Refresh token not found': 'Không tìm thấy refresh token',
  'Indicator not found': 'Không tìm thấy chỉ số',
  'Can not change chart': 'Không thể thay đổi biểu đồ',
  'Indicator invalid': 'Chỉ số không hợp lệ',
  'Unit invalid': 'Đơn vị không hợp lệ',
  'Invalid file extension': 'Phần mở rộng tệp không hợp lệ',
  'Job not found': 'Không tìm thấy công việc',
  'Can not delete folder': 'Không thể xóa thư mục',
  'Indicator value invalid': 'Giá trị chỉ số không hợp lệ',
  'Province not found': 'Không tìm thấy tỉnh',
  'Local indicator not found': 'Không tìm thấy chỉ số địa phương',
  'Local indicator value invalid': 'Giá trị chỉ số địa phương không hợp lệ',
  'Invalid file': 'Tệp không hợp lệ',
  'upload file failed': 'Tải lên tệp thất bại',
  'Not edit indicator type': 'Không thể chỉnh sửa loại chỉ số',
  'Indicator value not found': 'Không tìm thấy giá trị chỉ số',
  'Local indicator invalid': 'Chỉ số địa phương không hợp lệ',
  'Duplicate plan': 'Gói đã tồn tại',
  'Plan not found': 'Không tìm thấy gói',
  'Duplicate add-on': 'Tiện ích bổ sung đã tồn tại',
  'Addon not found': 'Không tìm thấy tiện ích bổ sung',
  'Article not found': 'Không tìm thấy bài viết',
  'Category not found': 'Không tìm thấy danh mục',
  'User not found': 'Không tìm thấy người dùng',
  'Default package not delete': 'Không thể xóa gói mặc định',
  'Not found': 'Không tìm thấy',
  'Tag not found': 'Không tìm thấy thẻ',
  'Tag Is Exist': 'Thẻ đã tồn tại',
  'Menu Config Is Exist': 'Cấu hình menu đã tồn tại',
  'Menu Config Is Not Exist': 'Cấu hình menu không tồn tại',
  'Id Value Is Not Exist': 'Giá trị ID không tồn tại',
  'Industry indicator not found': 'Không tìm thấy chỉ số ngành',
  'Not edit industry indicator type': 'Không thể chỉnh sửa loại chỉ số ngành',
  'Industry indicator invalid': 'Chỉ số ngành không hợp lệ',
  'Industry indicator value not found': 'Không tìm thấy giá trị chỉ số ngành',
  'Payment notification failed: ERR_FALSE_CHECKSUM ':
    'Thanh toán thất bại: ERR_FALSE_CHECKSUM',
};
